<script lang="ts">
    import type {Writable} from 'svelte/store'
    import ErrorForName from "./ErrorForName.svelte";

    export let form: Writable<any>
    export let errors: Writable<any>
    export let label: string
    export let name: string
    export let type: "text" | "email" | "textarea" = "text"
    export let handleChange: (event: Event) => any
</script>

<label for={name} class="form-label">{label}</label>
{#if type === "textarea"}
    <textarea class="form-control" id={name} on:change={handleChange}
           on:blur={handleChange}
              bind:value={$form[name]}></textarea>
{:else if type === "text"}
    <input type="text" class="form-control" id={name} on:change={handleChange}
           on:blur={handleChange}
           bind:value={$form[name]}>
{:else if type === "email"}
    <input type="email" class="form-control" id={name} on:change={handleChange}
           on:blur={handleChange}
           bind:value={$form[name]}>
{:else}
    Don't know how to do input of type {type}
{/if}

<ErrorForName errors={$errors} {name} />
